interface StartWorkingLabelState {
  busy: boolean;
  disabled?: boolean;
}

// Once work is under way the control is state, not an action, so it stops reading as a verb.
export const startWorkingLabel = ({
  busy,
  disabled,
}: StartWorkingLabelState): string => {
  if (busy) return "Starting...";
  if (disabled) return "In Progress";
  return "Start Working";
};
